// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


// Local RisingBee DataBase
export const environment = {
  production: false,
  projectOwnerId: 'aPLY3AFwDoRy88reOnVWTaSGSMm1', // 9685161113
  ownerName : 'New Welcome Agency',
  ownerUrl : 'https://rb-newwelcomeagency.web.app/',
  API_HOST : "https://risingbee-b2b-m-dev.appspot.com",
  APK : false,
  notificationServerKey : "AAAAD-7S79s:APA91bF3q8cwnKsvKpvNCPlfkDjTd4ap8Ibkk6uTQdIJ4lz66vuYvmlgGX3Rt7IU2Aqw83l0VDmQ4xvnX-XMEiIllbf5JwgkiIgubYgB5WIt6qSNrNTKVJBFxGXMz5XrDc_8n2PJlhz4", 

  firebase: {
    apiKey: "AIzaSyAchY_o_khTM-TLGTjVT0yPjLdGlanwejo",
    authDomain: "risingbee-b2b-dev.firebaseapp.com",
    databaseURL: "https://risingbee-b2b-dev.firebaseio.com",
    projectId: "risingbee-b2b-dev",
    storageBucket: "risingbee-b2b-dev.appspot.com",
    messagingSenderId: "68431310811",
    appId: "1:68431310811:android:dbbfd45f14e8a8ba"
  }
};

//Server RisingBee DataBase
// export const environment = {
//   production: false,
//   firebase :{
//   apiKey            : "AIzaSyA0h6u6BzLEKZ76XZaZ2Z9hAOieSYHYTCQ",
//   authDomain        : "risingbee-b2b.firebaseapp.com",
//   databaseURL       : "https://risingbee-b2b.firebaseio.com",
//   projectId         : "risingbee-b2b",
//   storageBucket     : "risingbee-b2b.appspot.com",
//   messagingSenderId : "972499491852",
//   appId             : "1:972499491852:android:dbbfd45f14e8a8ba"
//   }
// };
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
